/**
 * 日付の整形処理
 * @param date apiから取得した更新日 ex)2023-02-13T00:00:00Z
 * @param isDayName 曜日ありなしフラグ（falseの場合は曜日は表示しない）
 * @returns 整形した日付 ex)2023/2/13（月）
 */
export const formatDate = (date: string, isDayName = true) => {
  const conversionDate = new Date(date);
  const dayNames = '日月火水木金土';
  const formattedDate = `${conversionDate.getFullYear()}/${conversionDate.getMonth() + 1}/${conversionDate.getDate()}`;
  return isDayName
    ? `${formattedDate}（${dayNames[conversionDate.getDay()]}）`
    : formattedDate;
};

/**
 * 過去数日前の日付の整形処理
 * @param date apiから取得した更新日 ex)2023-02-13T00:00:00Z
 * @param pastDays 過去日数
 * @returns 整形した7日前の日付 ex)2023/2/6（月）
 */
export const formatPastDaysBeforeDate = (date: string, pastDays: number) => {
  const sevenDaysBeforeDate = new Date(date);
  sevenDaysBeforeDate.setDate(sevenDaysBeforeDate.getDate() - pastDays);
  return formatDate(sevenDaysBeforeDate.toDateString());
};

/**
 * 掲載日関連の整形処理（値がない、デフォルト値「0001-01-01」の場合、未定を返す）
 * @param date apiから取得した更新日 ex)2023-02-13T00:00:00Z
 * @returns 整形したの日付 または「未定」 ex)2023/2/6（月）
 */
export const convertPublicationDate = (date: string | null | undefined) => {
  if (!date) return '未定';
  const conversionDate = new Date(date);
  const defaultDate = new Date('0001-01-01');
  if (conversionDate.getTime() === defaultDate.getTime()) return '未定';
  return formatDate(date);
};
